export default __webpack_public_path__ + "static/media/learnEmpty.3561c7f1.svg";